import React from 'react';
import { observer } from 'mobx-react';
import { makeStyles } from '@mui/styles';
import { storeKrunica } from '../store/KrunicaStore';

const useStyles = makeStyles((theme) => ({
  opisMolitve: {
    justifyContent: 'space-between',
    marginTop: '0.5rem',
    textAlign: 'center',
    fontSize: '1.3rem',
    color: '#093145',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: '#e9e9e9',
      border: '1px solid #ece7e7',
      width: '50%',
      margin: 'auto',
      fontSize: '2rem',
    },
  },
  popuniProstor: {
    marginTop: '2rem',
  },
}));

function ZrnoText() {
  const classes = useStyles();
  const { aktivnaZemlja, zrno, prijevodOtajstvatext, trenutnaKrunica } =
    storeKrunica;
  // console.log('022=', trenutnaKrunica, zrno, aktivnaZemlja[`naslov${zrno}`]);

  if (trenutnaKrunica === 'gertruda' && zrno === 61) return null;
  if (trenutnaKrunica === 'bozijeMilosrde' && zrno === 58) return null;
  if (trenutnaKrunica === 'bozijeMilosrde')
    return (
      <React.Fragment>
        {zrno === -1 ? (
          <div className={classes.opisMolitve}></div>
        ) : (
          <div className={classes.popuniProstor}>
            {aktivnaZemlja[`naslov${zrno + 3}`]}
          </div>
        )}
      </React.Fragment>
    );
  if (trenutnaKrunica === 'pobjede')
    return (
      <React.Fragment>
        {zrno === -1 ? (
          <div className={classes.opisMolitve}></div>
        ) : (
          <div className={classes.popuniProstor}>
            {aktivnaZemlja[`naslov${zrno + 2}`]}
          </div>
        )}
      </React.Fragment>
    );

  return (
    <React.Fragment>
      <div className={classes.opisMolitve}>
        {zrno !== -1 ? (
          zrno === 0 ? (
            trenutnaKrunica === 'gospa' && <span>{prijevodOtajstvatext} †</span>
          ) : (
            <div>{aktivnaZemlja[`naslov${zrno}`]}</div>
          )
        ) : null}
      </div>
    </React.Fragment>
  );
}

export default observer(ZrnoText);
